import { convertMediaTrack } from './utils';
import { errorPlayerContainerNotCreated } from './errors';
export const playerAvailableSubtitlesTracks = (container) => {
    if (!container) {
        throw errorPlayerContainerNotCreated;
    }
    const player = container.getAny();
    return {
        availableSubtitlesTracks: {
            tracks: player.availableSubtitlesTracks.map(convertMediaTrack),
        },
    };
};
